import { CardState } from 'Prototype/Level/Card/CardState';
import { IGameState } from 'State/Game/IGameState';
import { isLevelCompletedSuccessfully } from 'State/Level/LevelStateHelper';
import CardStateHelper, { getCardsState } from '../CardStateHelper';
import BaseModifierBehavior from './BaseModifierBehavior';

export default class AutoCollectModifierBehavior extends BaseModifierBehavior {
    public play(state: IGameState): IGameState {
        return this.tryToCollect(state);
    }

    public update(state: IGameState): IGameState {
        return this.tryToCollect(state);
    }

    public onLevelStarted(state: IGameState): IGameState {
        return this.tryToCollect(state);
    }

    private tryToCollect(state: IGameState): IGameState {
        const cardState = CardStateHelper.getCardState(state, this.cardID);
        const cardBehavior = CardStateHelper.getCardBehavior(state.levelState.cardsState, this.cardID);
        const autoCollect =
            this.modifier.properties.autoCollectOnComplete && isLevelCompletedSuccessfully(state.levelState);

        if (
            // Ignore if not in play
            cardState !== CardState.IN_PLAY ||
            // Ignore if obscured and auto collect is not possible / enabled
            (cardBehavior.isObscured(state.levelState.cardsState) && !autoCollect)
        )
            return state;

        // Get targets so connected cards are included
        const targets = CardStateHelper.getTargets(state, this.cardID);

        // Collect card
        targets.forEach(cardID => {
            const cardBehavior = CardStateHelper.getCardBehavior(state.levelState.cardsState, cardID);
            state = cardBehavior.collectCard(state, {
                newCardState: CardState.DISCARDED,
                incrementStreak: false,
                addToTurnScore: false,
                pushToUndoHistory: false,
                updateModifiers: false,
            });
        });

        let cardsState = getCardsState(state);
        // Check for cards that need to be flipped after removing one
        cardsState = CardStateHelper.checkCardsObscured(cardsState);
        state = CardStateHelper.updateGameState(state, cardsState);

        return state;
    }
}
